import { render, staticRenderFns } from "./IndustryEditV2.vue?vue&type=template&id=3918f0e6"
import script from "./IndustryEditV2.vue?vue&type=script&lang=js"
export * from "./IndustryEditV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports